import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  captureAdAttribution,
  trackMetaPageView,
  trackViewContentForPath,
} from "../utils/metaPixel";

function MetaPixelTracker() {
  const location = useLocation();
  const isFirstPageViewRef = useRef(true);

  useEffect(() => {
    captureAdAttribution(location.search);
  }, [location.search]);

  useEffect(() => {
    trackViewContentForPath(location.pathname);

    if (isFirstPageViewRef.current) {
      isFirstPageViewRef.current = false;
      return;
    }

    trackMetaPageView();
  }, [location.pathname]);

  return null;
}

export default MetaPixelTracker;
